module.exports = __webpack_public_path__ + "static/vmware_14.0d68ef8b.jpg";